import React from "react";
import { useSelector } from "react-redux";

const Scorecards = () => {
  const scorecards = useSelector((state) => state.memberVisits.scorecards);

  if (!scorecards || !scorecards.length) return null;

  return (
    <div className="scorecards">
      {scorecards.map((elem, idx) => {
        return (
          <div className="scorecard" key={idx}>
            <div className="left">{elem.title}</div>
            <div className="right">{elem.body}</div>
          </div>
        );
      })}
    </div>
  );
};

export default Scorecards;
